<template>

    <trax-ui-ajax-form-in-modal :id="id" :endpoint="endpoint" 
        :props="props" :bus="bus" :form="form">

        <trax-ui-input type="text" :placeholder="lang.polaris.procedure.title"
            v-model="form.name" :error="errors.name" required="1">
        </trax-ui-input>

    </trax-ui-ajax-form-in-modal>
    
</template>

<script>
    export default {

        props: ['bus'],
    
        data: function() {
            return {
                lang: lang,
                learner: data.learner,
                endpoint: app_url+"polaris/api/front/procedures",
                id: 'enac-procedure-daf-widget-edit',
                form: {
                    registration_id: data.registration.id,
                    phase_id: data.phase.id,
                    user_id: data.learner ? data.learner.id : null
                },
                errors: {},
                props: {
                    name: { source:'name' }
                }
            }
        },

        created: function() {
            var that = this;

            this.bus.$on(that.id+'-errors', function(errors) {
                that.errors = errors;
            });

            this.bus.$on(that.id+'-data', function(data) {
                that.form = data;
            });
        }

    }
</script>
